import { ErrorMessage } from "./ErrorMessage";

export const ErrorMaintenance = () => (
  <ErrorMessage
    title="Layer is down for scheduled maintenance"
    description="We're upgrading our infrastructure and will be back shortly. Follow progress on our status page."
    showHelpLinks
  />
);
